import { ContactDataDisplayModel, ContactDataDisplayModelFormGroup } from '../../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';
import { Component, OnInit, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { GlobalEnumerationsAceInformationsquelle } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enumerations-ace-informationsquelle';
import { EnumValue } from '@/core/models/enumvalue.model';
import { I18nService } from '@/core/services/i18nService';
import { StateService } from '@/core/services/state.service';
import { SectionService } from '@/core/services/section.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { GlobalEnumerationsAceIdentischmit, KontaktDisplayModel, KontaktDisplayModelFormGroup } from '@/api/model-index';

@Component({
    selector: 'vertretungsberechtigte-form',
    templateUrl: './vertretungsberechtigte-form.component.html',
    styleUrls: ['./vertretungsberechtigte-form.component.scss'],
    standalone: false
})
export class VertretungsberechtigteFormComponent implements OnInit {
  @Input('form') contactDataForm: ContactDataDisplayModelFormGroup;

  public get informationsquelleList(): EnumValue[] {
    return this.translateservice.getEnumValues(GlobalEnumerationsAceInformationsquelle);
  }

  constructor(protected translateservice: I18nService, protected stateService: StateService, protected sectionService: SectionService, protected portalContextService: PortalContextService) {
  }

  ngOnInit(): void {
    if (this.stateService.IsEndvalidationEnabled) {
      this.contactDataForm.Informationsquelle.addValidators(Validators.required);
      this.contactDataForm.markAllAsTouched();
    }

    if (!this.portalContextService.isAnfrageStatusGrundInEntwurf() && this.portalContextService.isAnfrageInUeberarbeitung()) {
      if (this.sectionService.current()?.anstragstellerDatenUeberarbeiten == true) {
        if (this.contactDataForm.Vertretungsberechtigter.ZuBearbeiten.value == false) {
          this.contactDataForm.Vertretungsberechtigter.Firstname.disable();
          this.contactDataForm.Vertretungsberechtigter.Lastname.disable();
          this.contactDataForm.Vertretungsberechtigter.ContactInformation.EmailAddress.disable();
        }
      }
      else {
        this.contactDataForm.disable();
      }
    }

    this.contactDataForm.valueChanges.subscribe((contactData: ContactDataDisplayModel) => {
      this.updateIfIdentical(
        {
          [GlobalEnumerationsAceIdentischmit.Ansprechperson]: contactData.ansprechpartner,
          [GlobalEnumerationsAceIdentischmit.WeitereAnsprechperson]: contactData.weitererAnsprechpartner,
        },
        this.contactDataForm.Vertretungsberechtigter
      );

      this.updateIfIdentical(
        {
          [GlobalEnumerationsAceIdentischmit.Ansprechperson]: contactData.ansprechpartner,
          [GlobalEnumerationsAceIdentischmit.WeitereAnsprechperson]: contactData.weitererAnsprechpartner,
        },
        this.contactDataForm.WeitererVertretungsberechtigter
      );
    });
  }

  protected updateIfIdentical(sourceMap: { [key in GlobalEnumerationsAceIdentischmit]?: KontaktDisplayModel }, control: KontaktDisplayModelFormGroup): void {
    const identischMit: GlobalEnumerationsAceIdentischmit | undefined = control?.value?.identischmit;
    const source = identischMit ? sourceMap[identischMit] : null;
    if (source) {
      const newContact = Object.assign({}, source);
      newContact.id = null;
      newContact.identischmit = identischMit;
      control.patchValue(newContact, { emitEvent: false, onlySelf: false });
    }
  }
}
